import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function HeaderMainProtected({ specify, headline, headlineFontWeight, headlineNoWrap, headlineVariant }) {

    const weight = headlineFontWeight ?? 300;
    const variant = headlineVariant ?? "h3";

    return (
      <Box sx={{
        display: 'flex',
        flexDirection: headlineNoWrap ? 'row' : { xs: 'column', sm: 'row' },
        flexWrap: headlineNoWrap ? 'wrap' : 'nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: 1, sm: 1 },
      }}>
        <Typography variant={variant} textAlign='center'
                    sx={[ { color: 'greydark.C900', fontWeight: weight }, (theme) => theme.applyStyles('dark', {color: 'grey.C10', fontWeight: weight }), ]}>
          {headline}
        </Typography>

        <Typography variant={variant} textAlign='center' sx={[ {color: 'greydark.C900', fontWeight: '600'}, (theme) => theme.applyStyles('dark',{color: 'grey.C10', fontWeight: '600'})  ]}>
        {specify}
        </Typography>
      </Box>
    );
  }